module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/85.0d60c3ff.png";